import React, {useEffect} from 'react';
import moment from "moment";

import PropTypes from 'prop-types';
import {Toolbar, ToolbarItemPosition} from "controls/react/layout/toolbar";
import {Button} from "controls/react/form/button";
import {i18n} from 'core/localization';
import Window from "controls/react/kendoWrappers/window";
import {ScheduleTimeSettings} from "areas/reports/scheduleTimeSettings";
import {getTzOffsetDiffs} from "tools/dateTimeUtils"

export const b = require('b_').with('ceinterval');

function ScheduleWindow(props) {
	const [ruleData, setRuleData] = React.useState(null);
	const [valid, setValid] = React.useState(false);
	const scheduleTimeSettings = React.useRef(null);

	useEffect(() => {
		const rrule = props.rule.split(/[\r\n]/).find(x => x.startsWith('RRULE:')).replace('RRULE:', '');
		let timeZone = props.timeZone

		let startDateTimeString = props.rule.split(/[\r\n]/)
			.find(x => x.startsWith('DTSTART'))
			.replace('DTSTART;', '')
			.replace('DTSTART:', '');
		let startDateTime = null

		if(startDateTimeString.startsWith('TZID')){
			let pieces = startDateTimeString.split(/:/)
			startDateTimeString = pieces[1]
			timeZone = pieces[0].replace('TZID=', '')
			startDateTime = moment.tz(startDateTimeString, timeZone)
		}else {
			const offset = startDateTimeString.endsWith('Z')
				? getTzOffsetDiffs(moment.tz.guess(), props.timezone) * 60000
				: 0;
			startDateTime = moment(moment(startDateTimeString).valueOf() - offset)
		}

		setRuleData({
			rrule: rrule,
			timeZone: timeZone,
			startDateTime: startDateTime.format('YYYY-MM-DDTHH:mm:ss')
		})
	}, [props.timeZone])

	const onSave = React.useCallback(() => {
		const dtStartString = 'TZID=' + ruleData.timeZone + ':' + moment(ruleData.startDateTime).format('YYYYMMDDTHHmmss')
		const rruleString = `BEGIN:VEVENT\r\nDTSTART;${dtStartString}\r\nRRULE:${ruleData.rrule}\r\nEND:VEVENT`;
		props.onSave(rruleString);
	}, [ruleData]);

	const onChange = React.useCallback((value) => {
		setRuleData(value);
		setValid(scheduleTimeSettings.current?.store.isValid ?? false);
	}, [scheduleTimeSettings])

	const stopPropagation = React.useCallback((e) => {
		e.stopPropagation();
	}, [])

	return <div onClick={stopPropagation}>
		<Window modal={true} onClose={props.onCancel} width={'570px'}>
			<div className={b('window-inner')}>
				{ruleData && <ScheduleTimeSettings value={ruleData} onChange={onChange} ref={scheduleTimeSettings} />}
			</div>

			<Toolbar containerClass={b('toolbar')}>
				<Button title={i18n('Update')}
					primary={true}
					disabled={!valid}
					onClick={onSave}
					position={ToolbarItemPosition.AT_THE_END} />
				<Button title={i18n('Cancel')}
					primary={false}
					onClick={props.onCancel}
					position={ToolbarItemPosition.AT_THE_END} />
			</Toolbar>
		</Window>
	</div>
}

ScheduleWindow.propTypes = {
	rule: PropTypes.string.isRequired,
	onSave: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	timezone: PropTypes.string.isRequired
}

export default ScheduleWindow;
